class ProductCuff extends ProductConfigurator {
  constructor() {
    super();

    this.diamondLetters = this.querySelector("diamond-letters");
    this.diamondOptionRadioSelect = this.querySelector(
      ".option_diamonds radio-select"
    );

    this.addEventListener(
      "diamond-letters:change",
      this.onDiamondLettersChange
    );
  }

  onDiamondLettersChange(ev) {
    const el = ev.target;
    const value = el.diamondsCount;

    this.diamondOptionRadioSelect.querySelectorAll("input").forEach((input) => {
      if (input.value == value) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
}

customElements.define("product-cuff", ProductCuff);

const DiamondLettersCharacter = "❖";

class DiamondLetters extends HTMLElement {
  constructor() {
    super();

    this.textField = this.querySelector("input[type=text]");
    this.hiddenField = this.querySelector("input[type=hidden]");
    this.remainingCharacters = this.querySelector("var");
    this.textTemplate = this.dataset.textTemplate;
    this.previewTemplate = this.dataset.previewTemplate;
    this.allowedCodes = new RegExp(/^(Backspace|Arrow|Key|Digit|Space)/i)
    this.allowedCharacters = new RegExp(this.textField.pattern, "i");
    this.maxLength = this.textField.maxLength;

    if (!this.textField) return;

    this.buildLivePreview();

    this.addEventListener("keydown", this.onKeyDown.bind(this));
    this.addEventListener("keyup", this.onKeyUp.bind(this));
  }

  onKeyDown(ev) {
    const lengthReached = this.textField.value.length >= this.maxLength;
    const allowedCode = ev.code.match(this.allowedCodes);
    const allowedCharacter = ev.key.match(this.allowedCharacters);
    const allowedKeyCode = [8, 9, 16, 37, 39, 91].includes(ev.keyCode);

    if (!allowedCode) {
      ev.preventDefault();
    }

    if (!allowedCharacter && !ev.metaKey) {
      ev.preventDefault();
    }

    if (lengthReached && !allowedKeyCode && !(allowedCharacter && ev.metaKey)) {
      ev.preventDefault();
    }
  }

  onKeyUp(ev) {
    if ([9, 16, 37, 39, 91].includes(ev.keyCode)) {
      return;
    }

    this.updateTextAndPreview();
  }

  updateTextAndPreview() {
    this.updateFields();
    this.updateLivePreview();
  }

  updateFields() {
    const cursorStart = this.textField.selectionStart;

    this.sanitizedTextFromUser = this.textField.value.toUpperCase();
    this.textFromUserWithDiamonds = this.textTemplate
      .replace("${text}", this.sanitizedTextFromUser)
      .replaceAll(" ", DiamondLettersCharacter);
    this.finalTextForPreviewAndCheckout = this.previewTemplate
      .replace("${text}", this.sanitizedTextFromUser)
      .replaceAll(" ", DiamondLettersCharacter);
    this.diamondsCount =
      this.finalTextForPreviewAndCheckout.match(
        new RegExp(DiamondLettersCharacter, "g")
      )?.length || 0;
    this.textField.value = this.textFromUserWithDiamonds;
    this.hiddenField.value = this.finalTextForPreviewAndCheckout;

    this.textField.selectionStart = cursorStart;
    this.textField.selectionEnd = this.textField.selectionStart;

    this.setRemainingCharacters();
    this.dispatchEvent(
      new CustomEvent("diamond-letters:change", { bubbles: true })
    );
  }

  buildLivePreview() {
    this.previewContainers = document.querySelectorAll(".product__media");

    if (this.previews) return;
    if (this.previewContainers.length == 0) return;

    this.updateFields();

    this.previews = [];
    this.previewContainers.forEach((container) => {
      const preview = document.createElement("diamond-letters-preview");
      preview.dataset.initialValue = this.finalTextForPreviewAndCheckout;
      this.previews.push(preview);
      container.append(preview);

      this.updateTextAndPreview();
    });
  }

  updateLivePreview() {
    if (!this.previews) return;

    setTimeout(() => {
      this.previews.forEach((preview) =>
        preview.update(this.finalTextForPreviewAndCheckout)
      );
    }, 100);
  }

  setRemainingCharacters() {
    if (!this.remainingCharacters) return;

    this.remainingCharacters.textContent =
      this.maxLength - this.textField.value.length;
  }
}

customElements.define("diamond-letters", DiamondLetters);

class DiamondLettersPreview extends HTMLElement {
  constructor() {
    super();

    this.textSizeHeadroom = 30;
    this.baseImage = this.parentNode.querySelector(
      'better-image[data-src-id*="pc_preview_base"] picture'
    );
    this.letters = document.createElement("div");
    this.append(this.letters);

    this.debouncedAdaptTextSize = debounce(this.adaptTextSize.bind(this), 50);
  }

  update(text) {
    const characters = text.split("").map((char) => {
      const charSanitized = char.replace(DiamondLettersCharacter, "space");
      const symbol = document.getElementById(
        `diamond-letters_${charSanitized}`
      );
      const viewBox = symbol?.attributes["viewBox"]?.value;

      if (!viewBox) return "";
      return `<svg viewBox="${viewBox}" class="letter_${charSanitized}" focusable="false"><use href="#diamond-letters_${charSanitized}" /></svg>`;
    });
    this.letters.innerHTML = characters.join("");

    this.debouncedAdaptTextSize();
  }

  adaptTextSize() {
    if (!this.baseImage) {
      return;
    }

    this.baseImageBox = this.baseImage.getBoundingClientRect();
    if (this.baseImageBox.width == 0) {
      return;
    }
    this.lettersBox = this.letters.getBoundingClientRect();
    const scale = this.classList.contains("scaled-down") ? 1 / 0.75 : 1;
    const needsToBeScaledDown =
      (this.lettersBox.width + this.textSizeHeadroom) * scale >=
      this.baseImageBox.width;

    this.classList.toggle("scaled-down", needsToBeScaledDown);
  }
}

customElements.define("diamond-letters-preview", DiamondLettersPreview);
